import React from "react";

import { PageMain } from "components/molecules";
import { PaziaLoader } from "components/atoms";
import { TanTableClient, TanTableColumn } from "components/molecules";
import { PageRichHeader } from "components/molecules/PageHeader/PageRichHeader";
import { PaziaBox } from "components/atoms";
import { useContactFormSubmissions, shopApi, ContactFormSubmission } from "api/shop";
import { useToaster } from "utils";

export const ContactFormSubmissionsPage = ({ embedded }: { embedded?: boolean }) => {
  const { submissions, total, isLoading, invalidate } = useContactFormSubmissions(0, 200);
  const { showSuccess, showError } = useToaster();

  const handleDelete = async (submission: ContactFormSubmission) => {
    if (!window.confirm(`Czy na pewno chcesz usunąć zgłoszenie od "${submission.name} ${submission.surname}"?`)) return;
    try {
      await shopApi.deleteContactFormSubmission(submission.id);
      showSuccess("Zgłoszenie zostało usunięte");
      invalidate();
    } catch {
      showError("Nie udało się usunąć zgłoszenia");
    }
  };

  const columns = React.useMemo<TanTableColumn<ContactFormSubmission>[]>(
    () => [
      {
        id: "name",
        accessorKey: "name",
        header: "Imię",
        enableColumnFilter: false,
        size: 140,
      },
      {
        id: "surname",
        accessorKey: "surname",
        header: "Nazwisko",
        enableColumnFilter: false,
        size: 140,
      },
      {
        id: "email",
        accessorKey: "email",
        header: "Email",
        enableColumnFilter: false,
        size: 200,
      },
      {
        id: "phone",
        accessorKey: "phone",
        header: "Telefon",
        enableColumnFilter: false,
        size: 140,
      },
      {
        id: "message",
        accessorKey: "message",
        header: "Wiadomość",
        enableColumnFilter: false,
        size: 300,
        cell: (info) => {
          const message = info.getValue<string>() ?? "";
          return (
            <span className="block max-w-xs truncate" title={message}>
              {message}
            </span>
          );
        },
      },
      {
        id: "createdDate",
        accessorKey: "createdDate",
        header: "Data",
        enableColumnFilter: false,
        size: 150,
        cell: (info) => {
          const value = info.getValue<Date | string>();
          return value ? new Date(value).toLocaleString("pl-PL") : "";
        },
      },
    ],
    [],
  );

  const content = (
    <>
      <div className="mb-4 flex flex-wrap items-center justify-between gap-2">
        <h3 className="text-lg font-medium text-slate-800 dark:text-slate-200">
          Zgłoszenia z formularza kontaktowego ({total})
        </h3>
      </div>

      {isLoading ? (
        <PaziaLoader position="center" />
      ) : (
        <TanTableClient
          data={submissions}
          columns={columns}
          onDelete={(x) => handleDelete(x)}
          hideBorder
        />
      )}
    </>
  );

  if (embedded) return content;

  return (
    <PageMain>
      <PageRichHeader header="Zgłoszenia z formularza kontaktowego">
        <></>
      </PageRichHeader>
      <PaziaBox>{content}</PaziaBox>
    </PageMain>
  );
};
